module.exports = __webpack_public_path__ + "img/depthMap-bomber240.58c13afe.png";